
<div class="card-advanced-fields">
  <div class="advanced-link">
    <icon-link
      :icon="advancedOpen ? 'expand_less' : 'chevron_right'"
      @click="advancedOpen = !advancedOpen;"
    >
      Advanced
    </icon-link>
  </div>

  <br />

  <div :class="['advanced-details', { hidden: !advancedOpen }]">
    <section>
      <text-area-input
        v-if="showAdvancedField"
        id="ebayQuery"
        v-model="card.ebayQuery"
        label="Query"
        required
      />

      <text-input
        v-if="showAdvancedField && isStaff && !isCollection"
        id="cert"
        v-model.trim="card.cert"
        label="Cert #"
      >
        <icon-button
          v-show="isPsaSlab"
          icon="cl_psa_image"
          tooltip="Go to PSA Cert Page"
          @click="goToPsaCertPage"
        />
      </text-input>

      <tag-input
        v-if="isCollection"
        v-model="card.tags"
        label="Tags"
      />

      <text-area-input
        v-if="showAdvancedField"
        id="setInformation"
        v-model.trim="card.setInformation"
        label="Set Information"
      />

      <text-input
        v-if="showAdvancedField"
        id="setInformationLinkDescription1"
        v-model.trim="card.setInformationLinkDescription1"
        label="Set Link Description"
      />

      <text-input
        v-if="showAdvancedField"
        id="setInformationLinkUrl1"
        v-model.trim="card.setInformationLinkUrl1"
        type="url"
        label="Set Link URL"
      />

      <text-area-input
        v-if="showAdvancedField"
        id="cardInformation"
        v-model="card.cardInformation"
        label="Card Information"
      />

      <text-input
        v-if="showAdvancedField"
        id="cardInformationLinkDescription1"
        v-model.trim="card.cardInformationLinkDescription1"
        label="Card Link Description"
      />

      <text-input
        v-if="showAdvancedField"
        id="cardInformationLinkUrl1"
        v-model.trim="card.cardInformationLinkUrl1"
        type="url"
        label="Card Link URL"
      />

      <text-input
        v-if="showAdvancedField && isStaff && !isCollection"
        id="profileId"
        v-model.trim="card.profileId"
        label="Profile ID"
      />
    </section>

    <section v-if="!isCollection">
      <text-input
        id="player"
        v-model.trim="card.playerIndexId"
        label="Player Index ID"
        placeholder="Defaults to player"
        maxlength="50"
        :options="playerOptions"
        :loading="loadingPlayers"
        @input="loadPlayers"
      />

      <text-area-input
        v-if="card.hidden"
        v-model="card.adminNotes"
        label="Admin Notes"
      />

      <select-input
        id="employee"
        v-model="card.employee"
        label="Employee"
        :options="employeeOptions"
      />

      <checkbox
        id="keyCard"
        v-model="card.keyCard"
        label="Key Card"
      /><br />

      <checkbox
        id="auctionOnly"
        v-model="card.auctionOnly"
        label="Auction Only Sales when Scraping eBay"
      /><br />

      <checkbox
        id="autoAddSales"
        v-model="card.autoAddSales"
        label="Automatically add sales without pending"
      /><br />

      <checkbox
        id="manuallyReviewSales"
        v-model="card.manuallyReviewSales"
        label="Manually review sales of this card in pending always"
      /><br />

      <checkbox
        id="popIgnore"
        v-model="card.popIgnore"
        label="Do not track population"
      />
    </section>
  </div>
</div>
